export default __webpack_public_path__ + "static/media/Ingar_Sicune_CamTransicion_Edificio001.d55a8a4d.f78e97de.mp4";